export const DEFAULT_PAGE_SIZE = 10;

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 200];

// The ?pageSize= param is user-controlled and is fed straight into the GraphQL
// `first` / `skip` arguments, so anything outside the offered options is rejected
// rather than clamped — a NaN would fail the query and an arbitrarily large value
// would issue an unbounded one.
// Number() rather than parseInt() so a trailing-garbage value like '20abc' is
// rejected outright instead of silently parsing to 20.
export const parsePageSize = (value) => {
  const parsed = Number(value);
  return PAGE_SIZE_OPTIONS.includes(parsed) ? parsed : DEFAULT_PAGE_SIZE;
};
